import { SettingsState } from '@store/settings/settings.model';
import * as SettingsActions from '@store/settings/settings.actions';

export const settingsInitialState: SettingsState = {
  userPreferences: null
};

export function SettingsReducer(state: SettingsState = settingsInitialState, action: SettingsActions.All) {
  switch (action.type) {
    case SettingsActions.SAVE_CHANGES_USER_PREFERENCE:
      return {
        ...state,
        userPreferences: action.payload.userPreferences
      };

    case SettingsActions.GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        userPreferences: action.payload
      };
  }
}
